import React, { useState, useEffect, useRef } from 'react';
import AvatarEditor from 'react-avatar-editor';
import RotateLeftIcon from '../../../public/assets/images/icons/rotate-left.svg';
import RotateRightIcon from '../../../public/assets/images/icons/rotate-right.svg';
import ZoomInIcon from '../../../public/assets/images/icons/zoom-in.svg';
import ZoomOutIcon from '../../../public/assets/images/icons/zoom-out.svg';
import { ColumnWrapper, Wrapper, CropButton } from './styles';

const ImageCropper = ({ imageUrl, onCrop, setBlob }) => {
  const editor = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [moving, setMoving] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const cropImage = async () => {
      if (editor && editor.current) {
        const canvas = editor.current.getImage();
        onCrop(canvas.toDataURL('image/jpeg'));
        const blob = await getCanvasAsBlob(canvas);
        setBlob(blob);
      }
    };
    if (imageLoaded) {
      cropImage();
    }
  }, [rotation, scale, moving]);

  useEffect(() => {
    const cropImage = async () => {
      onCrop(null);
      setBlob(null);
    };
    if (imageLoaded) {
      cropImage();
    }
  }, [imageUrl]);

  const getCanvasAsBlob = async (canvas) => {
    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          blob.name = `hubImage_${Date.now()}`;
          resolve(blob);
        },
        'image/jpeg',
        1,
      );
    });
  };

  const rotateLeft = () => {
    if (rotation === -270) {
      setRotation(0);
    } else {
      setRotation(rotation - 90);
    }
  };

  const rotateRight = () => {
    if (rotation === 270) {
      setRotation(0);
    } else {
      setRotation(rotation + 90);
    }
  };

  const zoomIn = () => {
    setScale(scale + 0.2);
  };

  const zoomOut = () => {
    if (scale > 1) {
      setScale(scale - 0.2);
    }
  };

  const onImageReady = () => {
    setImageLoaded(true);
  };

  const onPositionChange = () => {
    setMoving(true);
  };

  const onMouseUp = () => {
    setMoving(false);
  };

  return (
    <Wrapper>
      <ColumnWrapper title={i18n.__('hub_image_move_focus')} border={true}>
        <AvatarEditor
          tabIndex={0}
          ref={editor}
          crossOrigin="anonymous"
          image={imageUrl}
          height={150}
          width={150}
          border={0}
          borderRadius={1000}
          color={[0, 0, 0, imageLoaded ? 0.5 : 0]}
          scale={scale}
          rotate={rotation}
          onImageReady={onImageReady}
          onPositionChange={onPositionChange}
          onMouseUp={onMouseUp}
        />
      </ColumnWrapper>
      <ColumnWrapper>
        <Wrapper>
          <CropButton
            tabIndex={0}
            role="button"
            title={i18n.__('hub_image_button.rotate_left')}
            src={RotateLeftIcon}
            onClick={rotateLeft}
            onKeyPress={rotateLeft}
          />
          <CropButton
            tabIndex={0}
            role="button"
            title={i18n.__('hub_image_button.rotate_right')}
            src={RotateRightIcon}
            onClick={rotateRight}
            onKeyPress={rotateRight}
          />
        </Wrapper>
        <Wrapper>
          <CropButton
            tabIndex={0}
            role="button"
            title={i18n.__('hub_image_button.zoom_in')}
            src={ZoomInIcon}
            onClick={zoomIn}
            onKeyPress={zoomIn}
          />
          <CropButton
            tabIndex={0}
            role="button"
            title={i18n.__('hub_image_button.zoom_out')}
            src={ZoomOutIcon}
            onClick={zoomOut}
            onKeyPress={zoomOut}
          />
        </Wrapper>
      </ColumnWrapper>
    </Wrapper>
  );
};

export default ImageCropper;
